import React from "react";

export const LoggedOutPage = () => {
    return <>
        <h1>You have been logged out successfully.</h1>

        <p><a href="/">Click here</a> to log back in.</p>
    </>
}